






import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class CopyToClipboard extends Vue {
    @Prop({
        required: true
    })
    content!: string;

    private copied: boolean = false

    private get isClipboardAvailable(): boolean {
        return navigator && 'clipboard' in navigator && 'writeText' in navigator.clipboard
    }

    public copyToClipboard() {
        this.copied = false

        if (this.isClipboardAvailable) {
            navigator.clipboard.writeText(this.content).then(() => (this.copied = true))
        }
    }
}
